module.exports = __webpack_public_path__ + "images/company/rank_medal/request_count_rank/2_8620066baa770725b2532a61ab693ebc.png";